import { ConnectionInformation } from "../messages/index.js";
export default function (app) {
    const connection = navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
    if (connection === undefined) {
        return;
    }
    const sendConnectionInformation = () => app.send(new ConnectionInformation(Math.round(connection.downlink * 1000), connection.type || 'unknown'));
    sendConnectionInformation();
    connection.addEventListener('change', sendConnectionInformation);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@openreplay/tracker/lib/modules/connection.js
// module id = 2659
// module chunks = 0